module.exports = __webpack_public_path__ + "static/img/phone.5ce5a42a.svg";